import { useTranslation } from "react-i18next";
import type { CatalogFilter } from "../../../../api/configuration";

/**
 * Мини-скица на екрана „Продукти" под настройката „Лентата над каталога":
 * вляво каталогът с кехлибарената лента отгоре (избраният филтър), вдясно
 * панелът с поръчката, над която стои другият филтър. Само форми, без данни.
 */
export function CatalogFilterIllustration({ value }: { value: CatalogFilter }) {
  const { t } = useTranslation();
  const topLabel = t(
    value === "stations"
      ? "orderingSettings.illustrationStations"
      : "orderingSettings.illustrationGroups",
  );
  const sideLabel = t(
    value === "stations"
      ? "orderingSettings.illustrationGroups"
      : "orderingSettings.illustrationStations",
  );

  return (
    <div className="mt-3 flex max-w-[320px] gap-2" aria-hidden>
      <div className="flex min-w-0 flex-1 flex-col rounded-[10px] border border-shade-2 bg-panel p-1.5">
        <div className="flex h-6 items-center gap-1.5 rounded-[6px] bg-brand px-2 text-[9px] font-bold uppercase tracking-[0.1em] text-white">
          <span className="h-1.5 w-1.5 rounded-full bg-white/80" />
          {topLabel}
        </div>
        <div className="mt-1.5 grid grid-cols-4 gap-1">
          {Array.from({ length: 8 }, (_, index) => (
            <span key={index} className="h-2.5 rounded-[4px] bg-brand-tint2" />
          ))}
        </div>
        <div className="mt-auto pt-3 text-[9.5px] text-muted">
          {t("orderingSettings.illustrationCatalog")}
        </div>
      </div>
      <div className="flex w-[74px] flex-shrink-0 flex-col rounded-[10px] border border-shade-2 bg-panel p-1.5">
        <div className="text-[9px] font-bold uppercase tracking-[0.1em] text-ink">
          {sideLabel}
        </div>
        <div className="mt-1.5 grid grid-cols-2 gap-1">
          {Array.from({ length: 4 }, (_, index) => (
            <span key={index} className="h-2.5 rounded-[4px] bg-fill-2" />
          ))}
        </div>
        <div className="mt-auto pt-5 text-[9.5px] text-muted">
          {t("orderingSettings.illustrationOrder")}
        </div>
      </div>
    </div>
  );
}
